/* eslint-disable no-use-before-define */
/* eslint-disable eqeqeq */
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { renderToString } from 'react-dom/server';
import { Dropdown, Form, Header, Segment, Button, Icon, Loader } from 'semantic-ui-react';
import { Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as authActions from '../actions/authActions';
import * as sessionActions from '../actions/sessionActions';
import * as profileActions from '../actions/profileActions';
import * as policyActions from '../actions/policyActions';
import * as vehicleActions from '../actions/vehicleActions';
import * as addressActions from '../actions/addressActions';
import * as claimActions from '../actions/claimActions';
import { policySelector, profileSelector, appSelector } from '../selectors';
import { push } from 'connected-react-router';
import AutoInformation from '../components/sections/claim/report/AutoInformation';
import { useDropzone } from 'react-dropzone';
import moment from 'moment';
import styles from './ReportClaimPage.module.scss';
import { states, statesByAbbreviation } from '../components/States';

import severityValues from '../components/sections/claim/SeverityValues';
import * as LossTypeValues from '../components/sections/claim/LossTypeValues';
import * as FnolTypes from '../components/sections/claim/FnolTypes';
import DatePicker from '../components/DatePicker';
import HelpButton from '../components/sections/policy/change/HelpButton';
import ThirdPartyDrivers from '../components/sections/claim/report/ThirdPartyDrivers';
import FormPhoneNumberField from '../components/sections/claim/report/FormPhoneNumberField';
import CancelModal from '../components/sections/policy/change/CancelModal';
import ConfirmationModal from '../components/sections/claim/ConfirmationModal';
import LongTextArea from '../components/LongTextArea';
import * as EmailValidator from 'email-validator';
import ErrorModal from '../components/ErrorModal';
import AdjusterEmailDetails from '../components/sections/claim/AdjusterEmailDetails';
import { animateScroll as scroll } from 'react-scroll';
import useDebounce from '../helpers/debounce';
import * as VehicleValues from '../components/sections/claim/VehicleValues';


const ReportClaimPage = ({ actions, profile, policies, app }) => {
	const [error, setError] = useState(null);
	const [fileList, setFileList] = useState([]);
	const [fileRejectionList, setFileRejectionList] = useState([]);
	const [showActionCancel, setShowActionCancel] = useState(false);
	const [exit, setExit] = useState(false);
	const [showConfirmCancelledPolicy, setShowConfirmCancelledPolicy] = useState(false);
	const [showSubmitConfirmed, setShowSubmitConfirmed] = useState(false);
	const [whatHappenedLength, setWhatHappenedLength] = useState(0);
	const [lossLocationLength, setLossLocationLength] = useState(0);
	const [claimNumber, setClaimNumber] = useState(null);
	const [showError, setShowError] = useState(false);
	const [errorClosed, setErrorClosed] = useState(false);
	const [errorEmailSent, setErrorEmailSent] = useState(false);
	const [policyNumber, setPolicyNumber] = useState();
	const [otherLocationAddressState, setOtherLocationAddressState] = useState({ otherLocationAddressLoading: false, previousZip: null });
	const canMakePayment = (app.systemToggles || { canMakePayments: false }).canMakePayments || false;
	const [policyChanged, setPolicyChanged] = useState(false);
	const [submittedClaim, setSubmittedClaim] = useState(null);

    const maxLossDate = Date.parse(moment(app.systemUtcDateTime).local());
	
	const cccClaimsEnabled = (app.systemToggles || { cccClaimsEnabled: false }).cccClaimsEnabled || false;
	
    const maximumIndividualAttachmentSize = 10485760;
    const maximumCombinedAttachmentSize = 20000000;
	const [aggregatedAttachmentSize, setAggregatedAttachmentSize] = useState(0);
	
	function attachmentValidation(file) {
		// check for duplicates
        if (fileList.some((x) =>
            moment(x.lastModifiedDate).isSame(file.lastModifiedDate) &&
            moment(x.lastModified).isSame(file.lastModified) &&
            x.name === file.name &&
            x.path === file.path &&
            x.size === file.size &&
            x.type === file.type
        )) {
            return {
                code: "duplicate_file",
                message: `Duplicated file`
            };
        }

		// check individual file size
		if (file.size > maximumIndividualAttachmentSize) {
            return {
                code: "attachment_size_exceeds_maximum",
                message: `File size exceeds the 10MB maximum.`
            };
        }

        return null;
    }

	function isClassCodeExists(classCode) {
		const combinedCodes = [];

		VehicleValues.cccLightVehPrimaryClassCodes.forEach(primaryCode => {
			VehicleValues.cccLightVehSecondaryClassCodes.forEach(secondaryCode => {
				combinedCodes.push(primaryCode + secondaryCode);
			});
		});

		VehicleValues.cccMedVehPrimaryClassCodes.forEach(primaryCode => {
			VehicleValues.cccMedVehSecondaryClassCodes.forEach(secondaryCode => {
				combinedCodes.push(primaryCode + secondaryCode);
			});
		});

		VehicleValues.CCCPrivatePassengerclasscodes.forEach(code => {
				combinedCodes.push(code);
		});

		//combinedCodes.push(VehicleValues.CCCPrivatePassengerclasscodes);

		return combinedCodes.includes(classCode);
	}

	const onCancel = useCallback(async () => {
		setShowActionCancel(true);
	}, []);

	const onActionCancelConfirm = useCallback(async () => {
		setShowActionCancel(false);
		setExit(true);
	}, []);

	const onErrorClose = useCallback(async () => {
		setShowError(false);
	}, []);

	const onDrop = useCallback(
		(acceptedFiles, fileRejections) => {
			const newList = fileList.map((x) => x);
			const newRejectionList = fileRejectionList.map((x) => x);

            acceptedFiles.forEach(function (file) {
                newList.push(file);
            });

			setFileList(newList);

            const combinedFileSize = newList.map(item => item.size).reduce((prev, curr) => prev + curr, 0);
			setAggregatedAttachmentSize(combinedFileSize);
			
			fileRejections.forEach(function (rejectedFile) {
				newRejectionList.push(rejectedFile);
			});

			setFileRejectionList(newRejectionList);
        },
		[fileList, fileRejectionList]
	);

	const fileDelete = useCallback(
		async (file, index) => {
			var newList = fileList.map((x) => x);
			newList.splice(index, 1);
			setFileList(newList);

			const combinedFileSize = newList.map(item => item.size).reduce((prev, curr) => prev + curr, 0);
			setAggregatedAttachmentSize(combinedFileSize);
		},
		[fileList]
	);

	const files = fileList.map((file, index) => (
		<li key={file.path}>
			{file.path} - {file.size} bytes <Button icon='trash' title='Remove' className={styles.trashButton} onClick={() => fileDelete(file, index)} />
		</li>
	));

	const fileRejectionItems = fileRejectionList.map((rejectedFile, index) => {
		return (
			<li key={index}>
				{rejectedFile.file.path} ({rejectedFile.file.size} bytes): <i>{rejectedFile.errors[0].message}</i>
			</li>
		);
	});

	const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
		onDrop,
		noClick: true,
		noKeyboard: true,
		accept: 'image/jpeg, image/png, image/gif, image/bmp, image/tiff, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf, text/csv, text/plain, application/rtf, audio/mpeg, video/mp4, audio/wav, video/x-msvideo, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, video/quicktime, video/x-ms-wmv, video/x-mpeg, application/vnd.ms-outlook',
		validator: attachmentValidation,
	});

	useEffect(() => {
		const load = async () => {
			try {
				const profileResult = await actions.getProfile();

				if (profileResult.response.policies.length > 0) {
					await actions.getPolicies(profileResult.response.policies);
				}
			} catch (error) {
				setError('Failed to load policy');
			}
		};

		if (!profile.loaded) {
			load();
		}
	}, [actions, profile.loaded]);

	const policyNumberOptions = useMemo(
		() =>
			policies.items
				.filter((p) => !['WCP', 'CUP', 'FUP', 'PUP'].includes(p.policyNumber.substring(0, 3)) && p.statusText !== 'Pending')
				.map((p, i) => {
					return {
						text: p.policyNumber,
						value: p.policyNumber,
						key: i,
					};
				}),
		[policies]
	);

	const selectDefaultPolicy = useEffect(() => {
		if (policies) {
			if (policies.items.filter((p) => !['WCP', 'CUP', 'FUP', 'PUP'].includes(p.policyNumber.substring(0, 3)) && p.statusText !== 'Pending').length === 1) {
				// if there's only one policy, select it
				setPolicyNumber(policies.items[0].policyNumber);
			}
		}
	}, [policies]);

	const policy = useMemo(() => policies.items.find((p) => p.policyNumber === policyNumber), [policies, policyNumber]);

	const [initialData] = useState({
		whatsDamaged: null,
		packagePart: null,
		packagePartId: null,
		policyHolder: null,
		secondaryPolicyHolder: null,
		insuredHomePhone: '',
		insuredWorkPhone: '',
		insuredCellPhone: '',
		preferredEmailAddress: '',
		differentThanInsured: null,
		lossTypeId: null,
		lossType: '',
		lossDate: null,
		lossLocation: '',
		severity: null,
		lossCity: '',
		medicalAttention: null,
		lossStateId: null,
		lossStateName: '',
		lossStateAbbreviation: '',
		whatHappened: '',
		thirdPartyDrivers: null,
		thirdParties: [],
		involvedDriverNum: null,
		involvedDriverFirstName: '',
		involvedDriverLastName: '',
		involvedVehicleNum: null,
		involvedVehicleMake: '',
		involvedVehicleModel: '',
		involvedVehicleYear: '',
		involvedVehicleVin: '',

		otherContactFirstName: '',
		otherContactLastName: '',
		waterDamageType: null,
		otherDamageType: null,
		otherContactHomePhone: '',
		otherContactWorkPhone: '',
		otherContactCellPhone: '',
		agency: null,
		policyId: '',
		policyImageNum: 0,
		fnolTypeId: 0,
		fnolType: '',
		policyStatus: '',
		isPropertyClaim: null,
		noDriverToggle: null,
		otherLocationAddressLine1: '',
		otherLocationAddressCity: '',
		otherLocationAddressStateId: null,
		otherLocationAddressZip: null,
		drivable: null,
		cccClaimConsent: 2,
		airbagDeployed: 0,
		insuredAddress: 0,
		cccPhone: ''
	});

	const [data, setData] = useState(initialData);
	const isAutoClaim = useMemo(() => policy && (['PPA', 'CAP'].includes(policy.policyNumber.substring(0, 3)) || data.whatsDamaged === 'Auto'), [data.whatsDamaged, policy]);
	const isFarmClaim = useMemo(() => policy && policy.policyNumber.includes('FAR'), [policy]);
	const isCRMClaim = useMemo(() => policy && policy.policyNumber.includes('CRM'), [policy]);
	const isCPPClaim = useMemo(() => policy && policy.policyNumber.includes('CPP'), [policy]);
	const isGARClaim = useMemo(() => policy && policy.policyNumber.includes('GAR'), [policy]);
	const isPIMClaim = useMemo(() => policy && policy.policyNumber.includes('PIM'), [policy]);
	const isCAPClaim = useMemo(() => policy && policy.policyNumber.includes('CAP'), [policy]);

	const cccClaimsDisplay = useMemo(() => {
		if (policy) {
			return policy && cccClaimsEnabled && (policy.policyNumber.includes('CAP') || policy.policyNumber.includes('PPA'));
		}
	}, [policy, cccClaimsEnabled]);

    const attachmentsExceedCombinedSizeLimit = useMemo(() => {
		if (policy) {
			return aggregatedAttachmentSize > maximumCombinedAttachmentSize
        }
	}, [policy, aggregatedAttachmentSize]);

	useEffect(() => {
		if (error && !errorEmailSent && policy && policy.agency.emails && policy.agency.emails.length > 0) {
			var _error = error;
			if (Array.isArray(_error)) {
				_error = _error.join(', ');
			}
			try {
				actions.sendClaimErrorEmail({
					policyNumber: policy.policyNumber,
					memberName: policy.policyHolder.displayName,
					policyholderAddress1: policy.policyHolder.address1,
					policyholderAddress2: policy.policyHolder.address2,
					policyholderPhone: data['insuredCellPhone'] || data['insuredHomePhone'] || data['insuredWorkPhone'] || '',
					policyholderEmail: profile.email,
					errorMessage: _error,
					agencyEmailAddress: policy.agency.emails[0],
				});

				console.log('Sent error email');
			} catch {
				console.log('Failed to send error email');
			}

			try {
				// send claim details for debugging
                actions.sendClaimDebugEmail(
                    policy.policyNumber,
					policy.policyHolder.displayName,
					_error,
					submittedClaim,
					fileList
                );
                console.log('Sent debug email');
			}
			catch (e) {
                console.log('Failed to send debug email');
            }

			setErrorEmailSent(true);
		}
	}, [actions, policy, error, data, profile, fileList, submittedClaim]);

	useEffect(() => {
		if (policy) {
			setData({
				...data,
				preferredEmailAddress: profile.email ? profile.email.trim() : '',
				policyHolder: policy.policyHolder,
				secondaryPolicyHolder: policy.secondaryPolicyHolder,
				agency: policy.agency,
				policyId: policy.policyId,
				policyImageNum: policy.policyImageNum,
				policyStatus: policy.statusText,
				insuredCellPhone: profile.phoneNumber ? profile.phoneNumber.trim() : '',
				packagePart: !isCPPClaim && policy.packageParts !== null ? policy.packageParts[0] : null,
				packagePartId: !isCPPClaim && policy.packageParts !== null ? policy.packageParts[0].Number : null,
				noDriverToggle: false,
				lossDate: maxLossDate,
			});

			setPolicyChanged(true);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [policy, profile]);

	const [fieldErrors, setFieldErrors] = useState({});

	const stateOptions = useMemo(
		() =>
			states.map((s, i) => {
				return {
					text: `${s.abbreviation}`,
					value: s.id,
					key: s.id,
				};
			}),
		[]
	);

	
	const cccValidClaim = useMemo(() => {
		const lossType = LossTypeValues.autoLossTypeValues.find((x) => x.value === data.lossTypeId);
		const lossTypeText = lossType ? LossTypeValues.autoLossTypeValues.find((x) => x.value === data.lossTypeId).text : '';
		const isLossValid = lossTypeText !== 'Damage only to glass' && lossTypeText !== 'Towing' && lossTypeText !== '' ? true : false;
		const selectedVehicle = data.involvedVehicleNum ? policy.vehicles.find((x) => x.vehicleNum === data.involvedVehicleNum) : null;
		const isCoverageValid = selectedVehicle ? selectedVehicle.coverages.some((x) => x.coverageType === 'PhysicalDamage' && (x.description === 'Comprehensive Coverage' || x.description === 'Collision Coverage')) : false;
		let isCollisionAndComprehensiveExists = selectedVehicle ? selectedVehicle.collision > 0 && selectedVehicle.comprehensive > 0 : false;
		let isCAPCollisionAndComprehensiveExists = selectedVehicle ? selectedVehicle.collisionDeductable > 0 && selectedVehicle.comprehensiveDeductable > 0 : false;

		isCollisionAndComprehensiveExists = isCAPClaim ? isCAPCollisionAndComprehensiveExists : isCollisionAndComprehensiveExists;

		const isBodyTypeOrClassCodeExists = selectedVehicle != null ? (isCAPClaim ? isClassCodeExists(selectedVehicle.classCode) : VehicleValues.bodyTypes.includes(selectedVehicle.bodyTypeID)): false;
		return policy && cccClaimsDisplay && isLossValid && isCoverageValid && isCollisionAndComprehensiveExists && isBodyTypeOrClassCodeExists;
		//return policy && cccClaimsDisplay && isLossValid && isCoverageValid && isCollisionAndComprehensiveExists ;
	}, [policy, data.lossTypeId, data.involvedVehicleNum, cccClaimsDisplay, isCAPClaim]);

	

	const cccClaimEligible = useMemo(() => {
		return cccValidClaim && data.drivable == 1 && data.airbagDeployed == 2 && data.insuredAddress == 1;
	}, [cccValidClaim, data.drivable, data.airbagDeployed, data.insuredAddress]);

	const isPropertyClaim = useMemo(() => {
		return policy && ((['DFR', 'BOP', 'CPP', 'HOM', 'CRM', 'FAR'].includes(policy.policyNumber.substring(0, 3)) && data.whatsDamaged && data.whatsDamaged === 'Property') || ['CIM', 'CPR', 'PIM'].includes(policy.policyNumber.substring(0, 3)) || (policy.policyNumber.includes('CPP') && data.whatsDamaged !== 'Auto'));
	}, [data.whatsDamaged, policy]);

	const isLiabilityClaim = useMemo(() => {
		return policy && ((['DFR', 'BOP', 'CPP', 'HOM', 'CRM', 'FAR', 'GAR', 'CPP'].includes(policy.policyNumber.substring(0, 3)) && data.whatsDamaged && data.whatsDamaged.includes('Liability')) || (policy.policyNumber.substring(0, 3) === 'CPP' && data.packagePart && data.packagePart.name.includes('Liability')) || policy.policyNumber.includes('CGL'));
	}, [data.whatsDamaged, data.packagePart, policy]);

	const displayOtherDamage = useMemo(() => {
		const packagePart = data.packagePart ? data.packagePart.name : '';
		return policy && data.lossTypeId === -1 && (isAutoClaim || ['CIM', 'PIM', 'CPR'].includes(policy.policyNumber.substring(0, 3)) || (['HOM', 'BOP', 'DFR'].includes(policy.policyNumber.substring(0, 3)) && data.whatsDamaged === 'Property') || (policy.policyNumber.substring(0, 3) === 'CPP' && packagePart !== 'Crime' && (packagePart === 'Inland Marine' || packagePart === 'Property' || data.whatsDamaged === 'Property')));
	}, [policy, data, isAutoClaim]);

	const waterDamageOptions = useMemo(() => {
		if (policy) {
			return LossTypeValues.waterDamageLossTypeValues
				.filter((x) => (x.policyTypes.length === 0 || x.policyTypes.includes(policy.policyNumber.substring(0, 3))) && (x.excludePolicyTypes.length === 0 || !x.excludePolicyTypes.includes(policy.policyNumber.substring(0, 3))))
				.map((s, i) => {
					return {
						text: s.text,
						value: s.value,
						key: s.value,
					};
				});
		}
	}, [policy]);

	const otherDamageOptions = useMemo(() => {
		if (policy) {
			if (isAutoClaim) {
				return LossTypeValues.otherDamageLossTypeValues
					.filter((x) => x.isAuto)
					.map((s, i) => {
						return {
							text: s.text,
							value: s.value,
							key: s.value,
						};
					});
			} else {
				return LossTypeValues.otherDamageLossTypeValues
					.filter((x) => !x.isAuto && (x.policyTypes === null || x.policyTypes.includes(policy.policyNumber.substring(0, 3))))
					.map((s, i) => {
						return {
							text: s.text,
							value: s.value,
							key: s.value,
						};
					});
			}
		}
	}, [isAutoClaim, isPropertyClaim, policy]);

	const lossTypeOptions = useMemo(() => {
		if (isAutoClaim) {
			return LossTypeValues.autoLossTypeValues.map((lt, i) => {
				return {
					text: lt.text,
					value: lt.value,
					key: lt.value,
				};
			});
		} else if (isPropertyClaim && !isLiabilityClaim) {
			if (isFarmClaim) {
				return LossTypeValues.farmLossTypeValues.map((lt, i) => {
					return {
						text: lt.text,
						value: lt.value,
						key: lt.value,
					};
				});
			} else if (isCRMClaim || (isCPPClaim && data.packagePart && data.packagePart.name.includes('Crime'))) {
				return LossTypeValues.crmCppPropertyLossTypeValues.map((lt, i) => {
					return {
						text: lt.text,
						value: lt.value,
						key: lt.value,
					};
				});
			} else if (isPIMClaim) {
				return LossTypeValues.pimLossTypeValues.map((lt, i) => {
					return {
						text: lt.text,
						value: lt.value,
						key: lt.value,
					};
				});
			}

			return LossTypeValues.propertyLossTypeValues.map((lt, i) => {
				return {
					text: lt.text,
					value: lt.value,
					key: lt.value,
				};
			});
		} else {
			return [];
		}
	}, [isAutoClaim, isLiabilityClaim, isPropertyClaim, isCRMClaim, isFarmClaim, isCPPClaim, data]);

	const severityOptions = useMemo(() => {
		if (isPropertyClaim || (isCPPClaim && data.packagePart === 'Crime' && data.whatsDamaged !== 'Auto') || data.packagePart === 'Property') {
			return severityValues
				.filter((x) => x.isProperty)
				.map((s) => {
					return {
						text: s.text,
						value: s.value,
						key: s.text.concat(s.value),
					};
				});
		} else {
			return severityValues.map((s) => {
				return {
					text: s.text,
					value: (isGARClaim || isCPPClaim) && s.altValue ? s.altValue : s.value,
					key: (isGARClaim || isCPPClaim) && s.altValue ? s.text.concat(s.altValue) : s.text.concat(s.value),
				};
			});
		}
	}, [isPropertyClaim, isGARClaim, data.packagePart, data.whatsDamaged, isCPPClaim]);

	const severityHelpList = useMemo(() => {
		if (isPropertyClaim) {
			return severityValues
				.filter((x) => x.isProperty)
				.map((x, i) => {
					return <li key={i}>{x.propertyHelp}</li>;
				});
		} else {
			return severityValues.map((x, i) => {
				return (
					<li key={i} className={styles.helpText}>
						{x.help}
					</li>
				);
			});
		}
	}, [isPropertyClaim]);

	const packagePartHelpList = useMemo(() => {
		return [
			<li key='1' className={styles.helpText}>
				{'Property - Was there damage to your building or building personal property?'}
			</li>,
			<li key='2' className={styles.helpText}>
				{'General Liability - Was there an injury to a person or property damage you may be liable for?'}
			</li>,
			<li key='3' className={styles.helpText}>
				{'Inland Marine - Was there theft or damage to any of your scheduled property?'}
			</li>,
			<li key='4' className={styles.helpText}>
				{'Crime - Was your loss the result of a criminal act? (ex.employee dishonesty)'}
			</li>,
			<li key='5' className={styles.helpText}>
				{'Garage - Was your loss pertaining to an auto? (ex.business transaction, car accident, etc.)'}
			</li>,
		];
	});

	const isAutoOrLiability = useMemo(() => policy && policy.policyNumber.includes('GAR'), [policy]);
	const isPropertyOrLiability = useMemo(() => policy && ['BOP', 'HOM', 'FAR', 'DFR', 'CRM'].includes(policy.policyNumber.substring(0, 3)), [policy]);
	const displayWhatsDamaged = useMemo(() => policy && (isAutoOrLiability || isPropertyOrLiability || (isCPPClaim && data.packagePart && (data.packagePart.name === 'Garage' || data.packagePart.name === 'Crime'))), [isAutoOrLiability, isPropertyOrLiability, isCPPClaim, policy, data]);
	const displaySeverity = useMemo(() => (!isLiabilityClaim && !isCPPClaim) || (isCPPClaim && data.packagePart && ((data.whatsDamaged && data.packagePart.name === 'Crime' && data.whatsDamaged === 'Property') || (data.whatsDamaged && data.packagePart.name === 'Garage' && data.whatsDamaged === 'Auto') || data.packagePart.name === 'Property' || data.packagePart.name === 'Inland Marine')), [policy, isLiabilityClaim, isCPPClaim, data]);

	const isMedicalDisplayed = useMemo(() => {
		if (!data.lossTypeId) return false;

		const lossType = LossTypeValues.autoLossTypeValues.find((x) => x.value === data.lossTypeId);
		return policy && isAutoClaim && data.lossTypeId && lossType && LossTypeValues.autoLossTypeValues.find((x) => x.value === data.lossTypeId).isMedicalDisplayed;
	}, [policy, isAutoClaim, data.lossTypeId]);

	const isThirdPartyDisplayed = useMemo(() => policy && isAutoClaim && data.lossTypeId === 193, [policy, isAutoClaim, data.lossTypeId]); // 'At least two vehicles involved in collision'

	const packagePartOptions = useMemo(() => {
		if (policy && policy.packageParts && isCPPClaim) {
			return policy.packageParts.map((o, i) => {
				return {
					text: o.name,
					value: o.number, // { number: o.number, name: o.name },
					key: i,
				};
			});
		}
		return null;
	}, [isCPPClaim, policy]);

	const whatsDamagedOptions = useMemo(() => {
		if (isAutoOrLiability) {
			return ['Person/Liability', 'Auto'].map((o, i) => {
				return {
					text: o,
					value: o,
					key: i,
				};
			});
		} else if (isCPPClaim && data.packagePart) {
			if (data.packagePart.name.includes('Garage')) {
				return ['Auto', 'Person/Liability'].map((o, i) => {
					return {
						text: o,
						value: o,
						key: i,
					};
				});
			} else if (data.packagePart.name.includes('Crime')) {
				return ['Person/Liability', 'Property'].map((o, i) => {
					return {
						text: o,
						value: o,
						key: i,
					};
				});
			} else if (data.packagePart.name.includes('General Liability')) {
				return ['Liability'].map((o, i) => {
					return {
						text: o,
						value: o,
						key: i,
					};
				});
			} else if (data.packagePart.name.includes('Property') || data.packagePart.name.includes('Inland Marine')) {
				return ['Property'].map((o, i) => {
					return {
						text: o,
						value: o,
						key: i,
					};
				});
			}
		} else if (isPropertyOrLiability) {
			return ['Person/Liability', 'Property'].map((o, i) => {
				return {
					text: o,
					value: o,
					key: i,
				};
			});
		}
	}, [isAutoOrLiability, isPropertyOrLiability, isCPPClaim, data.packagePart]);

	const fieldValidations = useMemo(() => {
		return {
			// TODO: update this to return an object: {bool error, int order, ref method}
			// true = OK, false = error
			// UPDATE: Rather than true/false, return NULL or error object
			packagePart: (d) => (policy && isCPPClaim ? d.packagePart !== null : true),
			whatsDamaged: (d) => (policy && displayWhatsDamaged ? d.whatsDamaged !== null : true),
			insuredHomePhone: (d) => d.insuredHomePhone.trim() !== '' || d.insuredWorkPhone.trim() !== '' || d.insuredCellPhone.trim() !== '',
			insuredWorkPhone: (d) => d.insuredHomePhone.trim() !== '' || d.insuredWorkPhone.trim() !== '' || d.insuredCellPhone.trim() !== '',
			insuredCellPhone: (d) => d.insuredHomePhone.trim() !== '' || d.insuredWorkPhone.trim() !== '' || d.insuredCellPhone.trim() !== '',
			preferredEmailAddress: (_, f) => f.trim() !== '' && EmailValidator.validate(f),
			differentThanInsured: (_, f) => f !== null,
			lossTypeId: (_, f) => (!isLiabilityClaim ? f !== null : true),
			lossDate: (_, f) => f !== null,
			lossLocation: (_, f) => f.trim() !== '',
			otherDamageType: (_, f) => (displayOtherDamage ? f !== null : true),
			waterDamageType: (d, f) => (isPropertyClaim && d.lossTypeId === -2 ? f !== null : true),
			severity: (_, f) => (displaySeverity ? f !== null : true),
			lossCity: (_, f) => f.trim() !== '',
			medicalAttention: (_, f) => (isMedicalDisplayed ? f !== null : true),
			lossStateId: (_, f) => f !== null,
			whatHappened: (_, f) => f.trim() !== '',
			thirdPartyDrivers: (_, f) => (isThirdPartyDisplayed ? f !== null : true),
			involvedDriverNum: (_, f) => (isAutoClaim && !isCPPClaim ? f !== null : true),
			involvedDriverFirstName: (d, f) => (isAutoClaim && (d.involvedDriverNum === -1 || (isCPPClaim && !d.noDriverToggle)) ? f.trim() !== '' : true),
			involvedDriverLastName: (d, f) => (isAutoClaim && (d.involvedDriverNum === -1 || (isCPPClaim && !d.noDriverToggle)) ? f.trim() !== '' : true),
			involvedVehicleNum: (_, f) => (isAutoClaim && !isCPPClaim ? f !== null : true),
			involvedVehicleMake: (d, f) => (isAutoClaim && (d.involvedVehicleNum === -1 || isCPPClaim) ? f.trim() !== '' : true),
			involvedVehicleModel: (d, f) => (isAutoClaim && (d.involvedVehicleNum === -1 || isCPPClaim) ? f.trim() !== '' : true),
			involvedVehicleYear: (d, f) => (isAutoClaim && (d.involvedVehicleNum === -1 || isCPPClaim) ? f !== '' : true),
			otherContactFirstName: (d, f) => (d.differentThanInsured ? f.trim() !== '' : true),
			otherContactLastName: (d, f) => (d.differentThanInsured ? f.trim() !== '' : true),
			otherContactHomePhone: (d, f) => (d.differentThanInsured ? d.otherContactHomePhone.trim() !== '' || d.otherContactWorkPhone.trim() !== '' || d.otherContactCellPhone.trim() !== '' : true),
			otherContactWorkPhone: (d, f) => (d.differentThanInsured ? d.otherContactHomePhone.trim() !== '' || d.otherContactWorkPhone.trim() !== '' || d.otherContactCellPhone.trim() !== '' : true),
			otherContactCellPhone: (d, f) => (d.differentThanInsured ? d.otherContactHomePhone.trim() !== '' || d.otherContactWorkPhone.trim() !== '' || d.otherContactCellPhone.trim() !== '' : true),
			cccClaimConsent: (_, f) => (cccClaimEligible ? f !== 2 : true),
			drivable: (_, f) => (cccValidClaim ? f !== null : true),
			airbagDeployed: (_, f) => (cccValidClaim ? f !== null : true),
			insuredAddress: (_, f) => (cccValidClaim ? f !== null : true),
			cccPhone: (d, f) => (d.cccClaimConsent == 1 && cccValidClaim ? d.cccPhone.trim() !== '' : true)
		};
	}, [policy, isAutoOrLiability, isPropertyOrLiability, isCPPClaim, isLiabilityClaim, isMedicalDisplayed, isThirdPartyDisplayed, isPropertyClaim, isAutoClaim, isGARClaim, displayOtherDamage, displayWhatsDamaged, displaySeverity, cccClaimEligible, cccValidClaim]);

	const onThirdPartyDataChange = useCallback(
		(_data) => {
			setData(_data);
			//onChange(null, { name: 'thirdPartyDrivers', value: _data.thirdPartyDrivers });
			const validationKeys = Object.keys(fieldValidations);
			const newErrors = {};
			validationKeys.forEach((key, i) => {
				var validation = fieldValidations[key];
				//if (validation && !validation(_data, _data[key])) {
				//	newErrors[key] = { content: 'Please fill out this field', pointing: 'right' };
					
				//}
			});

			setFieldErrors(newErrors);
		},
		[fieldValidations]
	);

	const onChange = useCallback(
		(e, { name, value, checked }) => {
			const newData = { ...data, [name]: value };

			if (name === 'noDriverToggle') {
				newData.noDriverToggle = checked;
			}
			if (name === 'lossStateId') {
				newData.lossStateAbbreviation = states.find((state) => state.id === value).abbreviation || '';
				newData.lossStateName = states.find((state) => state.id === value).name || '';
			}
			if (name === 'lossTypeId') {
				newData.waterDamageType = null;
				newData.otherDamageType = null;
			}
			if (name === 'packagePartId') {
				newData.packagePart = packagePartOptions.find((part) => part.value === value) || null;
				if (value) {
					const selectedPackagePart = packagePartOptions.find((part) => part.value === value);
					newData.packagePart = { name: selectedPackagePart.text, number: selectedPackagePart.value };
				} else {
					newData.packagePart = null;
				}
			}
			if (name === 'cccClaimConsent') {
				if (value === 1) {
					newData.cccPhone = newData.insuredCellPhone || newData.insuredWorkPhone || "";
				} else {
					newData.cccPhone = "";
				}
			}

			setData(newData);

			setPolicyChanged(false);

			const validation = fieldValidations[name];

			if (validation && !validation(newData, newData[name])) {
				if (['insuredHomePhone', 'insuredWorkPhone', 'insuredCellPhone'].includes(name)) {
					setFieldErrors({
						...fieldErrors,
						insuredHomePhone: { content: 'Please enter at least one phone number', pointing: 'above' },
						insuredWorkPhone: { content: 'Please enter at least one phone number', pointing: 'above' },
						insuredCellPhone: { content: 'Please enter at least one phone number', pointing: 'above' },
					});
				} else if (['otherContactHomePhone', 'otherContactWorkPhone', 'otherContactCellPhone'].includes(name)) {
					setFieldErrors({
						...fieldErrors,
						otherContactHomePhone: { content: 'Please enter at least one phone number', pointing: 'above' },
						otherContactWorkPhone: { content: 'Please enter at least one phone number', pointing: 'above' },
						otherContactCellPhone: { content: 'Please enter at least one phone number', pointing: 'above' },
					});
				} else {
					setFieldErrors({ ...fieldErrors, [name]: { content: 'Please fill out this field', pointing: 'above' } });
				}
			} else {
				const newErrors = { ...fieldErrors };

				// handle phone numbers where only one of the three is required
				if (['insuredHomePhone', 'insuredWorkPhone', 'insuredCellPhone'].includes(name)) {
					delete newErrors['insuredHomePhone'];
					delete newErrors['insuredWorkPhone'];
					delete newErrors['insuredCellPhone'];
				} else if (['otherContactHomePhone', 'otherContactWorkPhone', 'otherContactCellPhone'].includes(name)) {
					delete newErrors['otherContactHomePhone'];
					delete newErrors['otherContactWorkPhone'];
					delete newErrors['otherContactCellPhone'];
				} else {
					delete newErrors[name];
				}

				setFieldErrors(newErrors);
			}

			if (name === 'whatHappened') {
				setWhatHappenedLength(value.length);
			}

			if (name === 'lossLocation') {
				setLossLocationLength(value.length);
			}
		},
		[data, fieldErrors, fieldValidations]
	);

	const finalizeSubmit = useCallback(async () => {
		// initialize what will be sent
		const finalData = { ...initialData };

		// manipulate the data for final posting
		// universal values
		finalData.agency = data.agency;
		finalData.policyId = data.policyId;
		finalData.policyImageNum = data.policyImageNum;
		finalData.policyNumber = data.policyNumber;
		finalData.lossLocation = data.lossLocation;
		finalData.lossCity = data.lossCity;
		finalData.lossStateId = data.lossStateId;
		finalData.lossStateAbbreviation = data.lossStateAbbreviation;
		finalData.lossStateName = data.lossStateName;
		finalData.whatHappened = data.whatHappened;
		finalData.lossDate = moment(data.lossDate).utc().format();
		finalData.preferredEmailAddress = data.preferredEmailAddress;
		finalData.policyHolder = data.policyHolder;
		finalData.secondaryPolicyHolder = data.secondaryPolicyHolder;
		finalData.policyStatus = data.policyStatus;
		finalData.packagePart = data.packagePart;

		if (displayWhatsDamaged) {
			finalData.whatsDamaged = data.whatsDamaged;
		}

		if (isAutoClaim) {
			finalData.isPropertyClaim = false;
			finalData.involvedDriverNum = data.involvedDriverNum;
			finalData.involvedDriverFirstName = !data.noDriverToggle ? data.involvedDriverFirstName : '';
			finalData.involvedDriverLastName = !data.noDriverToggle ? data.involvedDriverLastName : '';
			finalData.involvedVehicleNum = data.involvedVehicleNum;
			finalData.involvedVehicleMake = data.involvedVehicleMake;
			finalData.involvedVehicleModel = data.involvedVehicleModel;
			finalData.involvedVehicleYear = data.involvedVehicleYear;
			finalData.involvedVehicleVin = data.involvedVehicleVin;

			if (isThirdPartyDisplayed) {
				finalData.thirdPartyDrivers = data.thirdPartyDrivers;
				finalData.thirdParties = data.thirdParties;
			}

			finalData.LossVehicleOwnerFirstName= policy.policyHolder.firstName;
			finalData.LossVehicleOwnerLastName = policy.policyHolder.lastName;
			finalData.LossVehicleOwnerDisplayName = policy.policyHolder.displayName;
			finalData.LossVehicleOwnerName = policy.policyHolder;
			if (cccValidClaim) {
				finalData.airbagDeployed = data.airbagDeployed;
				finalData.drivableId = data.drivable
				finalData.insuredAddress = data.insuredAddress
				if (data.insuredAddress == 1) {
					finalData.lossAddress = policy.addresses[0];
				}
			}

			if (cccClaimEligible) {
				finalData.cccClaimConsent = data.cccClaimConsent
				if (data.cccClaimConsent == 1) {
					finalData.cccPhone = data.cccPhone
				}
			}

			if (data.involvedVehicleNum !== -1 && policy.vehicles) {
				const selectedVehicle = policy.vehicles.find((x) => x.vehicleNum === data.involvedVehicleNum);

				if (selectedVehicle) {
					finalData.involvedVehicleMake = selectedVehicle.make;
					finalData.involvedVehicleModel = selectedVehicle.model;
					finalData.involvedVehicleYear = selectedVehicle.year;
					finalData.involvedVehicleVin = selectedVehicle.vin;
					
				}
			}

			if (data.involvedDriverNum !== -1 && policy.drivers) {
				const selectedDriver = policy.drivers.find((x) => x.driverNum === data.involvedDriverNum);
				if (selectedDriver) {
					finalData.involvedDriverFirstName = selectedDriver.firstName;
					finalData.involvedDriverLastName = selectedDriver.lastName;
				}
			}
		} else {
			finalData.isPropertyClaim = true;
		}

		if (!isMedicalDisplayed) {
			finalData.medicalAttention = null;
		} else {
			finalData.medicalAttention = data.medicalAttention;
		}

		finalData.insuredHomePhone = data.insuredHomePhone;
		finalData.insuredWorkPhone = data.insuredWorkPhone;
		finalData.insuredCellPhone = data.insuredCellPhone;

		if (data.differentThanInsured) {
			finalData.otherContactHomePhone = data.otherContactHomePhone;
			finalData.otherContactWorkPhone = data.otherContactWorkPhone;
			finalData.otherContactCellPhone = data.otherContactCellPhone;
			finalData.otherContactFirstName = data.otherContactFirstName;
			finalData.otherContactLastName = data.otherContactLastName;
		}

		finalData.severity = severityValues.find((x) => x.text === 'Minor Loss').value; // set the default

		if (isLiabilityClaim) {
			const lossType = isCPPClaim ? LossTypeValues.cppLiabilityLossTypeValues.find((x) => x.packageParts.includes(data.packagePart.name)) : LossTypeValues.liabilityLossTypeValues.find((x) => x.policyTypes.includes(policy.policyNumber.substring(0, 3)));

			finalData.lossTypeId = lossType.value;
			finalData.lossType = lossType.text;
		} else {
			finalData.severity = data.severity === severityValues.find((x) => x.text === "I don't know").value ? severityValues.find((x) => x.text === 'Minor Loss').value : data.severity || finalData.severity;

			if (isPropertyClaim && data.lossTypeId === -2) {
				finalData.lossTypeId = data.waterDamageType;
			} else if (data.lossTypeId === -1) {
				if (displayOtherDamage && data.otherDamageType !== -1) {
					finalData.lossTypeId = data.otherDamageType;
				} else {
					if (policy.policyNumber.substring(0, 3) === 'CPP') {
						const otherLossType = LossTypeValues.cppOtherLossTypeValues.find((x) => x.packageParts.includes(data.packagePart.name));

						finalData.lossTypeId = otherLossType.value;
					} else {
						const otherLossType = LossTypeValues.otherLossTypeValues.find((x) => x.policyTypes.includes(policy.policyNumber.substring(0, 3)));
						finalData.lossTypeId = otherLossType.value;
					}
				}
			} else {
				finalData.lossTypeId = data.lossTypeId;
			}

			const lossTypeArray = [].concat(LossTypeValues.otherLossTypeValues, LossTypeValues.autoLossTypeValues, LossTypeValues.farmLossTypeValues, LossTypeValues.propertyLossTypeValues, LossTypeValues.crmCppPropertyLossTypeValues, LossTypeValues.waterDamageLossTypeValues, LossTypeValues.otherDamageLossTypeValues);
			finalData.lossType = lossTypeArray.find((x) => x.value === finalData.lossTypeId).text;
		}

		let fnolType = null;

		const policyPrefix = policy.policyNumber.substring(0, 3);

		switch (policyPrefix) {
			case 'PPA':
				fnolType = FnolTypes.fnolTypeAuto;
				break;
			case 'CAP':
				fnolType = FnolTypes.fnolTypeCommercialAuto;
				break;
			case 'CIM':
			case 'PIM':
			case 'CPR':
				fnolType = FnolTypes.fnolTypeProperty;
				break;
			case 'CGL':
				fnolType = FnolTypes.fnolTypeLiability;
				break;
			default:
		}

		if (!fnolType && finalData.whatsDamaged) {
			if (finalData.whatsDamaged.includes('Liability')) {
				fnolType = FnolTypes.fnolTypeLiability;
			}

			if (finalData.whatsDamaged.includes('Property')) {
				fnolType = FnolTypes.fnolTypeProperty;
			}

			if (finalData.whatsDamaged.includes('Auto')) {
				fnolType = FnolTypes.fnolTypeAuto;
			}
		}

		if (!fnolType && finalData.packagePart) {
			if (finalData.packagePart.name === 'General Liability') {
				fnolType = FnolTypes.fnolTypeLiability;
			}

			if (finalData.packagePart.name === 'Inland Marine' || finalData.packagePart.name === 'Property') {
				fnolType = FnolTypes.fnolTypeProperty;
			}
		}

		if (fnolType) {
			finalData.fnolType = fnolType.text;
			finalData.fnolTypeId = fnolType.value;
		}

		try {
			setErrorEmailSent(false);
			const emailDetails = renderToString(<AdjusterEmailDetails policy={policy} data={finalData} />);

			const decpas = policy.declarations.sort((a, b) => new Date(b.printDate) - new Date(a.printDate));
			const decpaPrintUrl = decpas.length > 0 ? decpas[0].printUrl : null;

            setSubmittedClaim({
                ...finalData,
                policyNumber: policy.policyNumber,
                lossDate: moment(data.lossDate),
                decpaPrintUrl
            });

			const result = await actions.submitClaimV2({ ...finalData, policyNumber: policy.policyNumber, lossDate: moment(data.lossDate), decpaPrintUrl }, emailDetails, fileList);
			if (result) {
				setClaimNumber(result.response.claimNumber);
				setShowSubmitConfirmed(true);
			}
		} catch (error) {
			setError(error.error || error.message);
			setShowError(true);
		}
	}, [data, fileList, initialData, isThirdPartyDisplayed, isCPPClaim, isAutoClaim, isAutoOrLiability, isPropertyOrLiability, isMedicalDisplayed, actions, isLiabilityClaim, isPropertyClaim, policy, displayWhatsDamaged]);

	const onSubmit = useCallback(async () => {
		const validationKeys = Object.keys(fieldValidations);
		let focusField = '';
		const newErrors = {};

		validationKeys.forEach((key, i) => {
			var validation = fieldValidations[key];
			if (validation && !validation(data, data[key])) {
				let contentText = 'Please fill out this field';

				if (['insuredHomePhone', 'insuredWorkPhone', 'insuredCellPhone', 'otherContactHomePhone', 'otherContactWorkPhone', 'otherContactCellPhone'].includes(key)) {
					contentText = 'Please enter at least one phone number';
				} else if (['cccClaimConsent', 'medicalAttention', 'thirdPartyDrivers', 'differentThanInsured', 'drivable', 'airbagDeployed', 'insuredAddress'].includes(key)) {
					contentText = 'Please select a value';
				}

				const direction = key === 'cccClaimConsent' ? 'left' : 'above';

				newErrors[key] = { content: contentText, pointing: direction };
			} else if (['insuredHomePhone', 'insuredWorkPhone', 'insuredCellPhone', 'otherContactHomePhone', 'otherContactWorkPhone', 'otherContactCellPhone', 'cccPhone'].includes(key) && data[key]) {
				if (!/^\d{10}$/.test(data[key])) {
					newErrors[key] = 'Invalid phone number';
				}
			}

			if (newErrors[key] && !focusField) {
				focusField = key;
			}
		});

		if (focusField) {
			let focusElement = document.querySelector(`[name="${focusField}"]`);

			if (focusElement) {
				if (focusElement.nodeName === 'DIV') {
					focusElement = document.querySelector(`[id="${focusField}_FocusAnchor"]`);
				}

				if (focusElement) {
					if (navigator.userAgent.indexOf('Firefox') > -1) {
						scroll.scrollMore(focusElement.getBoundingClientRect().top - 250, { smooth: true });
					}

					focusElement.focus();
				}
			}
		}

		setFieldErrors(newErrors);

		if (Object.keys(newErrors).length === 0 && !attachmentsExceedCombinedSizeLimit) {
			if (policy.statusText === 'Cancelled') {
				setShowConfirmCancelledPolicy(true);
			} else {
				finalizeSubmit();
			}
		}
	}, [fieldValidations, data, policy, finalizeSubmit, isAutoClaim, attachmentsExceedCombinedSizeLimit]);

	const onActionConfirmSubmit = useCallback(async () => {
		setShowConfirmCancelledPolicy(false);
		finalizeSubmit();
	}, [finalizeSubmit]);

	const onSubmitConfirmed = useCallback(async () => {
		setShowSubmitConfirmed(false);
		setExit(true);
	}, []);

	const displayDetails = useMemo(() => {
		if (policy && (isAutoOrLiability || isPropertyOrLiability ? data.whatsDamaged !== null : true) && (isCPPClaim ? data.packagePart : true) && (displayWhatsDamaged ? data.whatsDamaged : true)) {
			return true;
		}

		return false;
	}, [policy, data, isAutoOrLiability, isPropertyOrLiability, isCPPClaim, displayWhatsDamaged]);

	const onOtherLocationAddressChange = useCallback(
		(changedData) => {
			const changedKeys = Object.keys(changedData);
			setData({ ...data, ...changedData }); //, changedFields: [...new Set([...data.changedFields, ...changedKeys])] });
		},
		[data]
	);

	const otherLocationAddressLookup = useCallback(
		async (zipCode) => {
			if (zipCode && zipCode.length === 5 && zipCode !== otherLocationAddressState.previousZip) {
				try {
					setOtherLocationAddressState({ loadingAddress: true });

					const result = await actions.addressLookup(zipCode);
					if (result) {
						const stateId = statesByAbbreviation[result.response.stateAbbrev];

						if (data.otherLocationAddressStateId !== stateId || data.otherLocationAddressCity !== result.response.city) {
							const changedAddressData = {
								otherLocationAddressStateId: stateId,
								otherLocationAddressCity: result.response.city,
							};

							onOtherLocationAddressChange(changedAddressData);
						}
					}
				} catch (error) {}
				setOtherLocationAddressState({ loadingAddress: false, previousZip: zipCode });
			}
		},
		[actions, onOtherLocationAddressChange]
	);

	const debounceOtherLocationAddressZip = useDebounce(data.otherLocationAddressZip, 500);
	useEffect(() => {
		if (!policyChanged) {
			otherLocationAddressLookup(debounceOtherLocationAddressZip);
		}
	}, [otherLocationAddressLookup, debounceOtherLocationAddressZip]);

	return (
		<div className={styles.container}>
            {errorClosed && <Redirect to='/' />}
            <div className={styles.heading}>
                <Icon className={styles.icon} name='handshake' size='big' />
                <div>
                    <div className={styles.title}>Report Claim</div>
                    <div>Fill in the fields below to report a claim.</div>
                </div>
            </div>

            {!policy && <div className={styles.warning}>To report a Workers' Compensation claim, please contact your agent.</div>}
            <Segment>
                <Form>
					<Form.Field control={Dropdown} label='Policy' name='policyNumber' options={policyNumberOptions} value={policyNumber} selection onChange={(_, { value }) => setPolicyNumber(value)} />
                    {isCPPClaim && (
						<Form.Field
							label={{
								children: (
									<label>
										Package Part{' '}
										<HelpButton wide>
											<ul>{packagePartHelpList}</ul>
										</HelpButton>
										<a name='packagePart_FocusAnchor' id='packagePart_FocusAnchor' href='' />
									</label>
								),
							}}
							name='packagePartId'
							required
							options={packagePartOptions}
							value={data.packagePartId}
							selection
							onChange={onChange}
							error={fieldErrors['packagePart']}
							control={Dropdown}
						/>
					)}

                    {displayWhatsDamaged && <Form.Field control={Dropdown} label={"What's damaged?"} name='whatsDamaged' required options={whatsDamagedOptions} value={data.whatsDamaged} selection onChange={onChange} error={fieldErrors['whatsDamaged']} />}
                </Form>
            </Segment>

            {displayDetails && (
				<div>
					<React.Fragment>
						<Form>
							<Segment>
								<Header className={styles.header}>Insured Information</Header>
								{policy && (
									<React.Fragment>
										<div className={styles.row}>
											<div className='field'>
												<label>Policyholder</label>
												{!policy.policyHolder.isCommercial ? (
													<div>
														{policy.policyHolder.firstName} {policy.policyHolder.lastName}
													</div>
												) : (
													<div>{policy.policyHolder.displayName}</div>
												)}
											</div>

											{cccClaimsDisplay && (
												<div className='field'>
													<label>Insured Address</label>
													<div>{policy.addresses[0].line1}</div>
													<div>
														{policy.addresses[0].city}, {policy.addresses[0].state} {policy.addresses[0].zip5}
													</div>
												</div>
											)}
										</div>
									</React.Fragment>
								)}
								<div className={styles.row}>
									<div style={{ minWidth: '200px' }}>
										<div>Please enter at least one of the following three phone numbers.</div>
										{cccClaimsDisplay && (
											<div>
												<FormPhoneNumberField name='insuredCellPhone' label='Insured Cell Phone' onChange={onChange} value={data.insuredCellPhone} error={fieldErrors['insuredCellPhone']} />
												<FormPhoneNumberField name='insuredHomePhone' label='Insured Home Phone' onChange={onChange} value={data.insuredHomePhone} error={fieldErrors['insuredHomePhone']} />
												<FormPhoneNumberField name='insuredWorkPhone' label='Insured Work Phone' onChange={onChange} value={data.insuredWorkPhone} error={fieldErrors['insuredWorkPhone']} />
											</div>
										)}
										{!cccClaimsDisplay && (
											<div>
												<FormPhoneNumberField name='insuredHomePhone' label='Insured Home Phone' onChange={onChange} value={data.insuredHomePhone} error={fieldErrors['insuredHomePhone']} />
												<FormPhoneNumberField name='insuredCellPhone' label='Insured Cell Phone' onChange={onChange} value={data.insuredCellPhone} error={fieldErrors['insuredCellPhone']} />
												<FormPhoneNumberField name='insuredWorkPhone' label='Insured Work Phone' onChange={onChange} value={data.insuredWorkPhone} error={fieldErrors['insuredWorkPhone']} />
											</div>
										)}
									</div>

									<div>
										<Form.Input name='preferredEmailAddress' label='Preferred Email Address' onChange={onChange} value={data.preferredEmailAddress} error={fieldErrors['preferredEmailAddress']} required type='email' />
									</div>
								</div>
							</Segment>

							<Segment>
								<div className={styles.row}>
									<div className={styles.requiredLabel}>Is the primary contact for this claim different than that of the insured?</div>
									<Form.Group className={styles.claimRadioGroup}>
										<Form.Radio id='differentThanInsuredYesRadio' required error={fieldErrors['differentThanInsured'] ? true : false} label='Yes' className={styles.check} name='differentThanInsured' checked={data.differentThanInsured === true} onChange={() => onChange(null, { name: 'differentThanInsured', value: true })} />
										<Form.Radio id='differentThanInsuredNoRadio' required error={fieldErrors['differentThanInsured']} label='No' className={styles.check} name='differentThanInsured' checked={data.differentThanInsured === false} onChange={() => onChange(null, { name: 'differentThanInsured', value: false })} />
									</Form.Group>
								</div>
								{data.differentThanInsured && (
									<div className={styles.row}>
										<div>
											<Form.Input name='otherContactFirstName' label='Contact First Name' onChange={onChange} required error={fieldErrors['otherContactFirstName']} />
											<Form.Input name='otherContactLastName' label='Contact Last Name' onChange={onChange} required error={fieldErrors['otherContactLastName']} />
											<div>Please enter at least one of the following three phone numbers.</div>
											{cccClaimsDisplay && (
												<div>
													<FormPhoneNumberField name='otherContactCellPhone' label='Cell Phone' onChange={onChange} value={data.contactCellPhone} error={fieldErrors['otherContactCellPhone']} />
													<FormPhoneNumberField name='otherContactHomePhone' label='Home Phone' onChange={onChange} value={data.contactHomePhone} error={fieldErrors['otherContactHomePhone']} />
													<FormPhoneNumberField name='otherContactWorkPhone' label='Work Phone' onChange={onChange} value={data.contactBusinessPhone} error={fieldErrors['otherContactWorkPhone']} />
												</div>
											)}
											{!cccClaimsDisplay && (
												<div>
													<FormPhoneNumberField name='otherContactHomePhone' label='Home Phone' onChange={onChange} value={data.contactHomePhone} error={fieldErrors['otherContactHomePhone']} />
													<FormPhoneNumberField name='otherContactCellPhone' label='Cell Phone' onChange={onChange} value={data.contactCellPhone} error={fieldErrors['otherContactCellPhone']} />
													<FormPhoneNumberField name='otherContactWorkPhone' label='Work Phone' onChange={onChange} value={data.contactBusinessPhone} error={fieldErrors['otherContactWorkPhone']} />
												</div>
											)}
										</div>
									</div>
								)}
							</Segment>
												

							{isAutoClaim && <AutoInformation policy={policy} data={data} onChange={onChange} errors={fieldErrors} isCPPClaim={isCPPClaim} cccClaimsDisplay={cccClaimsDisplay} />}
								<Segment>
									<Header className={styles.header}>Loss Information</Header>
									<div className={styles.row}>
										{!isLiabilityClaim && (
											<div>
												<a name='lossTypeId_FocusAnchor' id='lossTypeId_FocusAnchor' href='' />
												<Form.Field control={Dropdown} name='lossTypeId' label='Select the option that best describes your loss' selection options={lossTypeOptions} required onChange={onChange} value={data.lossTypeId} error={fieldErrors['lossTypeId']} />
												{isPropertyClaim && data.lossTypeId === -2 && (
													<span>
														<a name='waterDamageType_FocusAnchor' id='waterDamageType_FocusAnchor' href='' />
														<Form.Field control={Dropdown} required label='Select type of Water Damage' name='waterDamageType' options={waterDamageOptions} value={data.waterDamageType} selection onChange={onChange} error={fieldErrors['waterDamageType']} />
													</span>
												)}
												{displayOtherDamage && (
													<span>
														<a name='otherDamageType_FocusAnchor' id='otherDamageType_FocusAnchor' href='' />
														<Form.Field control={Dropdown} required label='Further describe your loss' name='otherDamageType' options={otherDamageOptions} value={data.otherDamageType} selection onChange={onChange} error={fieldErrors['otherDamageType']} />
													</span>
												)}
											</div>
										)}
										<Form.Field error={fieldErrors['lossDate']} label='Loss Date' required control={DatePicker} name='lossDate' onChange={onChange} selected={data.lossDate} type='date' maxDate={maxLossDate} />
									</div>

									<div className={styles.row}>
										<Form.Field required error={fieldErrors['lossLocation']} control={LongTextArea} label='Loss Location' name='lossLocation' onChange={onChange} value={data.lossLocation} length={lossLocationLength} maxLength={2048} rows={1} />
										{displaySeverity && (
											<Form.Field
												required
												error={fieldErrors['severity']}
												control={Dropdown}
												label={{
													children: (
														<label>
															Severity{' '}
															<HelpButton wide>
																<ul>{severityHelpList}</ul>
															</HelpButton>
															<a name='severity_FocusAnchor' id='severity_FocusAnchor' href='' />
														</label>
													),
												}}
												name='severity'
												selection
												options={severityOptions}
												onChange={onChange}
												value={data.severity}
											/>
										)}
									</div>

									<div className={styles.row}>
										<Form.Input name='lossCity' label='Loss City' onChange={onChange} value={data.lossCity} required error={fieldErrors['lossCity']} />
										{isMedicalDisplayed && (
											<Form.Group grouped>
												<label className={styles.requiredLabel}>Did anyone seek medical attention?</label>
												<Form.Group inline className={styles.claimRadioGroup}>
													<Form.Radio id='medicalAttentionYesRadio' required error={fieldErrors['medicalAttention'] ? true : false} className={styles.check} name='medicalAttention' label='Yes' checked={data.medicalAttention === 1} onChange={() => onChange(null, { name: 'medicalAttention', value: 1 })} />
													<Form.Radio id='medicalAttentionNoRadio' required error={fieldErrors['medicalAttention'] ? true : false} className={styles.check} name='medicalAttention' label='No' checked={data.medicalAttention === 0} onChange={() => onChange(null, { name: 'medicalAttention', value: 0 })} />
													<Form.Radio id='medicalAttentionUnknownRadio' required name='medicalAttention' label='Unknown' error={fieldErrors['medicalAttention']} checked={data.medicalAttention === -1} onChange={() => onChange(null, { name: 'medicalAttention', value: -1 })} />
												</Form.Group>
											</Form.Group>
										)}
										
									</div>

									

									<div className={styles.row}>
										<span>
											<a name='lossStateId_FocusAnchor' id='lossStateId_FocusAnchor' href='' />
										<Form.Field control={Dropdown} name='lossStateId' label='Loss State' selection options={stateOptions} search required onChange={onChange} value={data.lossStateId} error={fieldErrors['lossStateId']} className={(cccClaimsDisplay && cccValidClaim) ? '' : styles.lossState} />
										
										</span>

									{cccClaimsDisplay && cccValidClaim && (
												<Form.Group grouped>
													<label className={styles.requiredLabel}>Did the vehicle's airbag deploy?</label>
													<Form.Group inline className={styles.claimRadioGroup}>
														<Form.Radio id="airbagDeployedYesRadio" required error={fieldErrors['airbagDeployed'] ? true : false} label='Yes' className={styles.check} name='airbagDeployed' checked={data.airbagDeployed === 1} onChange={() => onChange(null, { name: 'airbagDeployed', value: 1 })} />
														<Form.Radio id="airbagDeployedNoRadio" required error={fieldErrors['airbagDeployed'] ? true : false} label='No' className={styles.check} name='airbagDeployed' checked={data.airbagDeployed === 2} onChange={() => onChange(null, { name: 'airbagDeployed', value: 2 })} />
														<Form.Radio id="airbagDeployedUnknownRadio" required error={fieldErrors['airbagDeployed']} label='Unknown' className={styles.check} name='airbagDeployed' checked={data.airbagDeployed === 3} onChange={() => onChange(null, { name: 'airbagDeployed', value: 3 })} />
													</Form.Group>
												</Form.Group>
										)}

									</div>

									<div className={styles.row}>
										<span>
										<LongTextArea length={whatHappenedLength} maxLength={2048} name='whatHappened' label='Tell us what happened' onChange={onChange} value={data.whatHappened} required error={fieldErrors['whatHappened']} />

										</span>

									{cccClaimsDisplay && cccValidClaim && (
											<Form.Group grouped>
												<label className={styles.requiredLabel}>Is the vehicle able to be driven?</label>
												<Form.Group inline className={styles.claimRadioGroup}>
													<Form.Radio id="drivableYesRadio" required error={fieldErrors['drivable'] ? true : false} label='Yes' className={styles.check} name='drivable' checked={data.drivable === 1} onChange={() => onChange(null, { name: 'drivable', value: 1 })} />
													<Form.Radio id="drivableNoRadio" required error={fieldErrors['drivable'] ? true : false} label='No' className={styles.check} name='drivable' checked={data.drivable === 2} onChange={() => onChange(null, { name: 'drivable', value: 2 })} />
													<Form.Radio id="drivableUnknownRadio" required error={fieldErrors['drivable']} label='Unknown' className={styles.check} name='drivable' checked={data.drivable === -1} onChange={() => onChange(null, { name: 'drivable', value: -1 })} />
												</Form.Group>
											</Form.Group>
										)}

								</div>

								<div className={styles.row}>
									{cccClaimsDisplay && cccValidClaim && (
											<Form.Group grouped>
												<label className={styles.requiredLabel}>Is the vehicle located at the insured's address?</label>
												<Form.Group inline className={styles.claimRadioGroup}>
													<Form.Radio id="insuredAddressYesRadio" required error={fieldErrors['insuredAddress'] ? true : false} label='Yes' className={styles.check} name='insuredAddress' checked={data.insuredAddress === 1} onChange={() => onChange(null, { name: 'insuredAddress', value: 1 })} />
													<Form.Radio id="insuredAddressNoRadio" required error={fieldErrors['insuredAddress'] ? true : false} label='No' className={styles.check} name='insuredAddress' checked={data.insuredAddress === 2} onChange={() => onChange(null, { name: 'insuredAddress', value: 2})} />
													<Form.Radio id="insuredAddressUnknownRadio" required error={fieldErrors['insuredAddress']} label='Unknown' className={styles.check} name='insuredAddress' checked={data.insuredAddress === -1} onChange={() => onChange(null, { name: 'insuredAddress', value: -1 })} />
												</Form.Group>
											</Form.Group>
										)}
									
									</div>
								</Segment>
							

							{isThirdPartyDisplayed && <ThirdPartyDrivers data={data}  onChange={onThirdPartyDataChange} errors={fieldErrors} policyNumber={policy.policyNumber} />}
							<Segment>
								<section>
									<div {...getRootProps({ className: isDragActive ? styles.dropActive : (attachmentsExceedCombinedSizeLimit ? styles.dropError : styles.dropzone) })} title='Files Accepted: image/jpeg, image/png, image/gif, image/bmp, image/tiff, application/vnd.ms-excel, application/ vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf, text/csv, text/plain, application/rtf, audio/mpeg, video/mp4, audio/wav, video/x-msvideo, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/vnd.ms-outlook, video/quicktime, video/x-ms-wmv, video/x-mpeg'>
										<input {...getInputProps()} />
										<p>Please upload any supporting documents/images (10MB file size limit). Drag and drop files here, or click "Browse" to select.</p>
										<button type='button' onClick={open}>
											Browse
										</button>
									</div>

									{attachmentsExceedCombinedSizeLimit && (
									    <div className={styles.dropErrorText}>
											The selected files exceed the maximum combined size limit of 20MB.  Please remove attachments until falling below the limit.  You will be provided with your adjuster's contact information after your claim is successfully submitted.  Additional files can then be sent directly to your adjuster.
									    </div>
									)}

									{fileList.length > 0 && (
										<aside>
											<h4>Selected Files:</h4>
											<ul>{files}</ul>
										</aside>
									)}

									{fileRejectionList.length > 0 && (
										<aside>
											<h4>Rejected Files:</h4>
											<ul>{fileRejectionItems}</ul>
										</aside>
									)}
								</section>

							</Segment>

							{cccClaimEligible && (
								<Segment>
									<Header className={styles.header}>Virtual Appraisal</Header>
									<div className={styles.column}>
										<label className={`${styles.requiredLabel} ${styles.cccClaimConsentLabel}`}>
											<strong>We are committed to quickly resolving your claim. The fastest way for us to get a damage estimate written is to receive photos of your vehicle. Do you have a smartphone with a camera and are you willing to take some photos? </strong>
											
										</label>
										<p></p>
										<label className={` ${styles.cccClaimConsentLabel}`}>
											<i>	Participation in our photo-based estimating process does not confirm nor imply coverage for your claim. Your claim will be adjusted based on the facts of your claim and the terms and conditions of the applicable Indiana Farmers Insurance policy. </i>
										</label>
										<p></p>
										<Form.Group className={styles.cccClaimConsentGroup}>
											<Form.Radio id='cccClaimConsentYesRadio' required label='Yes' error={fieldErrors['cccClaimConsent'] ? true : false} className={styles.cccClaimConsentCheck} name='cccClaimConsent' checked={data.cccClaimConsent === 1} onChange={() => onChange(null, { name: 'cccClaimConsent', value: 1 })} />
											<Form.Radio id='cccClaimConsentNoRadio' required error={fieldErrors['cccClaimConsent']} label='No' className={styles.cccClaimConsentCheck} name='cccClaimConsent' checked={data.cccClaimConsent === 0} onChange={() => onChange(null, { name: 'cccClaimConsent', value: 0 })} />
										</Form.Group>
									</div>
								</Segment>
							)}
							{cccClaimEligible && data.cccClaimConsent == 1 && (
								<Segment>
									<div className={styles.column}>
										<label className={`${styles.requiredLabel} ${styles.cccClaimConsentLabel}`}>
											<strong>Please enter a cell phone number you would like us to use to communicate via text with you regarding the photo taking process. </strong>
										</label>
										<FormPhoneNumberField name='cccPhone' onChange={onChange} value={data.cccPhone} error={fieldErrors['cccPhone']} />
										
									</div>
								</Segment>
							)}
						</Form>
						<div className={styles.buttonContainer}>
							<Button id='submitBtn' onClick={onSubmit} primary>
								Submit
							</Button>
							<Button id='cancelBtn' onClick={onCancel} primary>
								Cancel
							</Button>
						</div>
					</React.Fragment>
				</div>
			)}

            <CancelModal open={showActionCancel} onConfirm={onActionCancelConfirm} onClose={() => setShowActionCancel(false)} />

            <ConfirmationModal header='Confirm Claim Submission' open={showConfirmCancelledPolicy} onConfirm={onActionConfirmSubmit} onClose={() => setShowConfirmCancelledPolicy(false)}>
                <p>You are about to submit a claim on a cancelled policy.</p>
                <p>Do you wish to continue?</p>
            </ConfirmationModal>

            <ConfirmationModal header='Claim Confirmation' open={showSubmitConfirmed} onConfirm={onActionConfirmSubmit} showAlertOnly onClose={onSubmitConfirmed}>
                {(data.cccClaimConsent == 0 || !cccClaimEligible) && <p>You have successfully submitted your claim! We will be in touch soon.</p>}
				{(data.cccClaimConsent == 1 && cccClaimEligible) && <><p>Thank you! You have successfully submitted your claim!</p><p>You will receive a text walking you through the quick estimate process.</p></>}
                {claimNumber && <p>Your claim number is {claimNumber}.</p>}
                <p>If your need is urgent, please give us a call at 800.477.1660.</p>
            </ConfirmationModal>

            {policy && data.agency && (
				<ErrorModal open={showError} agency={data.agency} onClear={() => setErrorClosed(true)} error={error} title='Something Went Wrong'>
					<p>We&#39;re sorry. We are currently experiencing a technical issue with our website. While we work to fix it as quickly as possible, please contact your agent to discuss your claim. Their contact info is below. Thank you for your patience and understanding.</p>
					{claimNumber && <p>Your claim number is {claimNumber}.</p>}
				</ErrorModal>
			)}
            
            {exit && <Redirect to='/' />}

        </div>
	);
};

ReportClaimPage.propTypes = {};

const mapStateToProps = (state) => {
	return {
		profile: profileSelector(state),
		policies: policySelector(state),
		app: appSelector(state),
	};
};
const mapDispatchToProps = (dispatch) => ({
	actions: {
		...bindActionCreators({ push }, dispatch),
		...bindActionCreators(authActions, dispatch),
		...bindActionCreators(profileActions, dispatch),
		...bindActionCreators(policyActions, dispatch),
		...bindActionCreators(sessionActions, dispatch),
		...bindActionCreators(vehicleActions, dispatch),
		...bindActionCreators(addressActions, dispatch),
		...bindActionCreators(claimActions, dispatch),
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportClaimPage);
